<!--
* A checkbox component
*
* @param {string} uncheckedSrc - Image source url for the unchecked image
* @param {string} checkedSrc - Image source url for the checked image
* @param {boolean} isCheckedOnInit - Whether the checkbox should be checked on init
*
* @fires appCheckbox#change
-->

<!--
* @event appCheckbox#change
* @property {boolean} checked  Whether the the checkbox is checked
-->
<!--
  @todo update v-model rather than allowing initial checked state
   and emiting event
-->
<template>

  <div class="app_image_checkbox"
       v-bind:class="{ selected: selected }"
       @click="onClick">
    <!-- photo box -->
    <div class="app_image_checkbox__image_wrapper"
         v-if="image">
      <img class="app_image_checkbox__image"
           v-bind:src="image" />
    </div>

    <!-- caption and checkbox -->
    <div class="app_image_checkbox__footer"
         v-bind:class="{ app_image_checkbox__footer_border: !image }">
      <!-- checkbox -->
      <app-checkbox
        :uncheckedSrc="uncheckedSrc"
        :checkedSrc="checkedSrc"
        ref="checkbox"
        :selected="selected"
        @change="onCheckboxChange" />
      <!-- Caption -->
      <div
        class="form__image_caption">{{caption}}</div>
    </div>
  </div>

</template>

<script>
  export default {
    props: {
      selected: {
        required: true,
        type: Boolean
      },
      uncheckedSrc: {
        required: true,
        type: String
      },

      checkedSrc: {
        required: true,
        type: String
      },

      caption: {
        type: String
      },

      image: {
        type: String
      }
    },
    data: function () {
      return {
      }
    },
    methods: {
      onCheckboxChange: function (selected) {
        this.$emit('update:selected', selected)
        this.$emit('change', selected)
      },
      onClick: function () {
        let checkbox = this.$refs.checkbox
        checkbox.onClick()
      }
    },
    computed: {
    }
  }
</script>

<style scoped lang="scss">
  @import "../assets/sass/shared.scss";

  .app_image_checkbox {
    cursor: pointer;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  // keep the highlighted border if view is selected
  .app_image_checkbox.selected {
    .app_image_checkbox__image_wrapper {
      border: $secondary-border-style;
      border-bottom: 0;
    }
    .app_image_checkbox__footer {
      border: $secondary-border-style;
      border-top: $default-border-style;
    }
    .app_image_checkbox__footer_border {
      border-top: $secondary-border-style;
    }
  }

  // on hover show the selected border
  @media (hover: hover) {
    .app_image_checkbox {
      &:hover {
        .app_image_checkbox__image_wrapper {
          border: $secondary-border-style;
          border-bottom: 0;
        }
        .app_image_checkbox__footer {
          border: $secondary-border-style;
          border-top: $default-border-style;
        }
        .app_image_checkbox__footer_border {
          border-top: $secondary-border-style;
        }
      }
    }
  }

  .app_image_checkbox__image_wrapper {
    display: flex;
    width: 100%;
    background: $quaternary-brand-color;
    border: $default-border-style;
    border-bottom: 0;
    font-size: $medium-font-size;
  }


  .app_image_checkbox__image {
    display: block;
    margin-left: auto;
    margin-right: auto;
    user-select: none;
    height: $dims-image-checkbox-height;
  }

  .app_image_checkbox__footer {
    pointer-events: none;
    display: flex;
    width: 100%;
    background: $secondary-brand-color;
    padding: $dims-spacing-small;
    border: $default-border-style;
    font-size: $medium-font-size;
  }

  .form__image_caption {
    display: block;
    width: 100%;
    padding-left: $dims-spacing-small;
    font-size: $medium-font-size;
  }
</style>
